import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React, { useContext } from 'react';
import classnames from 'classnames';
import { Url } from '@wix/da-url';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import PromoBadge from '@wix/da-ds/pkg/Badges/PromoBadge';
import { useSubscriptionTier } from '../../../../utils/hooks/useSubscriptionTier';
import Background from '../../../../Background';
import { DEFAULT_STATUS_PATTERNS } from '../../../../Background/constants';
import TextRenderer from '../../../../TextRenderer';
import { ShortStatusViewer } from '../../../../DaEditorWrapper/Viewer/Status';
import { getStatusBackgroundProps } from '../../../_helpers';
import draftTheme from '../../../../DaEditorWrapper/Themes/Viewer/feedcard.scss';
import legacyTheme from '../../feedcard.legacy.theme.scss';
import s from './ShortStatus.scss';
// note: only short statuses have backgrounds
// TODO: these are custom versions of the backgrounds in Background/constants.ts
// used in the postfeed (w/ a variant for mobile) - look into simplifying.
// Until then and for delete-ability, these are here instead of there.
const POSTFEED_STATUS_PATTERNS = [
    'meteors',
    'hearts',
    'stars',
    'planets'
];
const PATTERN_CDN_PATH = '/eclipse/global/svg/status-backgrounds';
/** Replaces one of the standard Background status patterns with a custom one for the postfeed */ function buildPatternUrl(pattern, isMobile) {
    const index = DEFAULT_STATUS_PATTERNS.indexOf(pattern);
    // e.g. desktop: 'https://st.deviantart.net/eclipse/global/svg/status-backgrounds/meteors.svg',
    // mobile: 'https://st.deviantart.net/eclipse/global/svg/status-backgrounds/meteors-mobile.svg',
    const newPattern = POSTFEED_STATUS_PATTERNS[index];
    const mobileSuffix = isMobile ? '-mobile' : '';
    return newPattern ? Url.staticCDNLink(`${PATTERN_CDN_PATH}/${newPattern}${mobileSuffix}.svg`) : undefined;
}
const ShortStatusFeedCardContents = ({ deviation, width })=>{
    var _backgroundProps;
    const isMobile = useContext(MobileContext);
    const { tier } = useSubscriptionTier(deviation);
    let backgroundProps = getStatusBackgroundProps(deviation);
    const customPattern = buildPatternUrl((_backgroundProps = backgroundProps) === null || _backgroundProps === void 0 ? void 0 : _backgroundProps.pattern, isMobile);
    if (customPattern) {
        backgroundProps = _object_spread_props(_object_spread({}, backgroundProps), {
            pattern: customPattern
        });
    }
    return /*#__PURE__*/ React.createElement(Background, _object_spread({
        className: classnames(s['background'], !!tier && s['in-tier']),
        contentClassName: s['background-content'],
        width: width,
        variant: "status"
    }, backgroundProps), !!tier && /*#__PURE__*/ React.createElement(PromoBadge, {
        badgeType: "tier",
        size: 40
    }), /*#__PURE__*/ React.createElement(TextRenderer, {
        textContent: deviation.textContent,
        reactViewer: ShortStatusViewer,
        viewerKey: deviation.deviationId,
        legacyTheme: "short-status",
        fixedParagraph: false,
        disableLazyLoading: true,
        draftjsThemeOverride: draftTheme,
        className: classnames(legacyTheme['legacy'], legacyTheme['override'], draftTheme['override'], legacyTheme['short-status'])
    }));
};
ShortStatusFeedCardContents.displayName = 'ShortStatusFeedCardContents';
export default ShortStatusFeedCardContents;
